import React from 'react'
import {Form, Input, InputNumber, Row} from "antd";


const {TextArea} = Input

const ScrapStockAmountSelection = ({stockLabel, handler, stockId, index, remover}) => {
    const handleAmountChange = ({target}) => {
        const noteFormName = `note-${index}`

        if (!+target.value){
            remover(noteFormName, stockId)
            return
        }

        handler('quantity', target.value, stockId)
    }
    const handleNoteChange = ({target}) => handler('note', target.value, stockId)

    return(
        <React.Fragment>
            <Form.Item
                label={stockLabel}
            >
                <Row>
                    <Form.Item
                        noStyle
                        name={`quantity-${index}`}
                    >
                        <InputNumber
                            onBlur={handleAmountChange}
                            style={{width: '50%', marginRight: '16px'}}
                            min={0}
                            step={0.1}
                            placeholder={'Miktar Giriniz'}
                        />
                    </Form.Item>
                </Row>
                <Row>
                    <Form.Item
                        name={`note-${index}`}
                        noStyle
                        rules={[
                            {max: 300, message: 'Not Alanı En Fazla 300 Karakter Olabilir'}
                        ]}
                    >
                        <TextArea
                            placeholder={'Not giriniz'}
                            onBlur={handleNoteChange}
                        />
                    </Form.Item>
                </Row>
            </Form.Item>
        </React.Fragment>
    )
}
export default ScrapStockAmountSelection